// ----------------------------------------------------------------------
// <copyright file="Izenda.DateTimePickerByDateElement.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Date Time Picker component
 */
import { map, times, omit, getOr, get, identity } from "lodash/fp";
import React, { Component, PropTypes } from "react";
import moment from "moment";
import { GROUP_BY as GROUP_BY_DATE } from "logic/data/Izenda.TimeFormatConstants";
import DateTimePicker from "./DateTime/Izenda.DateTimePicker";
import NumericInput from "./Izenda.NumericInput";
import uiState from "logic/Izenda.UiState";
import { notifyChange, DROPDOWN } from "EventUtils";
import DropDown from "./Izenda.DropDown";

export default class DateTimePickerByDateElement extends Component {
  static propTypes = {
    groupByDateTime: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)])
  };

  constructor(props) {
    super(props);
    this.getWeekdayOptions();
  }

  getWeekdayOptions() {
    this.weekdayOptions = map(
      index => ({
        value: index + 1,
        label: moment(index + 1, GROUP_BY_DATE.weekday.COMPARE_FORMAT, true).format(
          GROUP_BY_DATE.weekday.DISPLAY_DATE_FORMAT
        )
      }),
      times(identity, 7)
    );
  }

  render() {
    const props = this.props;
    const { groupByDateTime: groupBy, onChange } = props;
    const rest = omit(["groupBy"], props);

    if (!groupBy) {
      return <DateTimePicker {...rest} />;
    }
    
    const setting = GROUP_BY_DATE[groupBy];
    switch (setting) {
      case GROUP_BY_DATE.day:
      case GROUP_BY_DATE.month:
      case GROUP_BY_DATE.year:
      case GROUP_BY_DATE.quarter:
        return <NumericInput {...rest} {...setting.NUMBER_PICKER_PROPS} />;
      case GROUP_BY_DATE.weekday:
        return (
          <DropDown
            {...rest}
            onChange={notifyChange(onChange, DROPDOWN)}
            options={this.weekdayOptions}
            labelKey="label"
            valueKey="value"
          />
        );
      default:
        return (
          <DateTimePicker
            {...omit(["dateTimeFormatData"], props)}
            {...setting.DATE_PICKER_PROPS}
            displayFormat={getOr(
              setting.DISPLAY_DATE_FORMAT,
              "[" + uiState.currentUser.dateFormat + "]",
              setting.DISPLAY_DATE_FORMAT
            )}
            storeFormat={get("COMPARE_FORMAT", setting)}
          />
        );
    }
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.DateTimePickerByDateElement.js